<template>
<div class="chapter">
<div class="inner_page">
<h2 class="BHD">NOZZLES</h2>
<p class="INTRO1">Nozzles, or piping tips, can produce all the effects that you need to create amazingly realistic flowers. They come in different sizes and brands, and each brand has its corresponding numbers or letters inscribed on it to indicate its output. We've indicated which nozzles you need in each of the flower instructions that follow, but here's a general guide to show you which nozzle does what.</p>
<div class="IMAGE">
<p class="image-center"><img alt="" src="images/C1-F4.jpg"/></p>
<p class="CAP1">Wilton 103 petal nozzle</p>
</div>
<div class="IMAGE">
<p class="image-center"><img alt="" src="images/C1-F5.jpg"/></p>
<p class="CAP1">Wilton 104 petal nozzle</p>
</div>
<div class="IMAGE">
<p class="image-center"><img alt="" src="images/C1-F6.jpg"/></p>
<p class="CAP1">Wilton 126 petal nozzle</p>
</div>
<div class="IMAGE">
<p class="image-center"><img alt="" src="images/C1-F7.jpg"/></p>
<p class="CAP1">Wilton 150 petal nozzle</p>
</div>
<div class="IMAGE">
<p class="image-center"><img alt="" src="images/C1-F8.jpg"/></p>
<p class="CAP1">Wilton 81 chrysanthemum nozzle</p>
</div>
<div class="IMAGE">
<p class="image-center"><img alt="" src="images/C1-F9.jpg"/></p>
<p class="CAP1">Wilton 352 leaf nozzle</p>
</div>
<div class="IMAGE">
<p class="image-center"><img alt="" src="images/C1-F10.jpg"/></p>
<p class="CAP1">Wilton 366 leaf nozzle</p>
</div>
<div class="IMAGE">
<p class="image-center"><img alt="" src="images/C1-F11.jpg"/></p>
<p class="CAP1">PME 32R Supatube petal nozzle</p>
</div>
<div class="IMAGE">
<p class="image-center"><img alt="" src="images/C1-F12.jpg"/></p>
<p class="CAP1">PME 57R Supatube petal nozzle</p>
</div>
<div class="IMAGE">
<p class="image-center"><img alt="" src="images/C1-F13.jpg"/></p>
<p class="CAP1">PME 58R Supatube petal nozzle</p>
</div>
<div class="IMAGE">
<p class="image-center"><img alt="" src="images/C1-F14.jpg"/></p>
<p class="CAP1">PME ST50 Supatube leaf nozzle</p>
</div>
<div class="IMAGE">
<p class="image-center"><img alt="" src="images/C1-F15.jpg"/></p>
<p class="CAP1">PME ST51 Supatube leaf nozzle</p>
</div>
<div class="IMAGE">
<p class="image-center"><img alt="" src="images/C1-F16.jpg"/></p>
<p class="CAP1">PME 5 Supatube star nozzle</p>
</div>
<div class="IMAGE">
<p class="image-center"><img alt="" src="images/C1-F17.jpg"/></p>
<p class="CAP1">PME 42 Supatube rope nozzle</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter13.vue?6a7e2ffa